import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_all_categories_api = async (params) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.get(`${MICROSERVICE_CONFIG.RESTAURANT}/menu/categories?${params}`)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const delete_category_by_id_api = async (id) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.delete(`${MICROSERVICE_CONFIG.RESTAURANT}/menu/categories/${id}`)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const add_food_categories = async (payload) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.post(`${MICROSERVICE_CONFIG.RESTAURANT}/menu/categories`, payload, {
				headers: { "Content-Type": "multipart/form-data" },
			})
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const update_food_categories = async (body) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.patch(
				`${MICROSERVICE_CONFIG.RESTAURANT}/menu/categories/${body.id}`,
				body.fileData,
				{ headers: { "Content-Type": "multipart/form-data" } }
			)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const get_all_sub_categories_api = async (params) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.get(
				`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${params}/menu/sub-categories`
			)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
